var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_6707",
    "data-name": "Group 6707",
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.027,
    height: 19.82,
    viewBox: "0 0 29.027 19.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    d: "M-2585.12-1857a12.055,12.055,0,0,0,1.78-3.792.625.625,0,0,0-.112-.485,7.34,7.34,0,0,1-1.911-4.685,7.01,7.01,0,0,1,1.985-4.957,12.518,12.518,0,0,1,7.319-3.787,15.814,15.814,0,0,1,10.1,1.353,9.71,9.71,0,0,1,4.389,4.086,6.83,6.83,0,0,1-.775,7.583,11.981,11.981,0,0,1-6.742,4.041,16.2,16.2,0,0,1-10.009-.665.757.757,0,0,0-.553.061A11.323,11.323,0,0,1-2585.12-1857Zm13.921-8.963a1.8,1.8,0,0,0-1.787-1.868,1.834,1.834,0,0,0-1.919,1.828,1.833,1.833,0,0,0,1.836,1.87A1.806,1.806,0,0,0-2571.2-1865.967Zm3.953-1.868a1.8,1.8,0,0,0-1.855,1.842,1.8,1.8,0,0,0,1.842,1.856,1.824,1.824,0,0,0,1.858-1.843A1.817,1.817,0,0,0-2567.246-1867.836Zm-9.768,1.865a1.8,1.8,0,0,0-1.833-1.865,1.811,1.811,0,0,0-1.865,1.834,1.817,1.817,0,0,0,1.834,1.865A1.805,1.805,0,0,0-2577.015-1865.971Z",
    transform: "translate(2585.364 1874.994)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    d: "M-2407.041-1816.386a7.337,7.337,0,0,0,1.912-4.685,7.009,7.009,0,0,0-1.985-4.957,11.911,11.911,0,0,0-5.565-3.38,9.384,9.384,0,0,1,3.669,3.7,6.831,6.831,0,0,1-.775,7.583,11.983,11.983,0,0,1-6.742,4.041,16.258,16.258,0,0,1-8.78-.229,13.553,13.553,0,0,0,3.905,1.567,16.2,16.2,0,0,0,10.009-.665.757.757,0,0,1,.553.061,11.323,11.323,0,0,0,5.467,1.247,12.06,12.06,0,0,1-1.78-3.791A.626.626,0,0,1-2407.041-1816.386Z",
    transform: "translate(2434.156 1831.928)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/Chat.6eb167e17d39c7f3ebed9c23863cbe19.svg";
export { ForwardRef as ReactComponent };